import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { DEFAULT_TITLE, AUTHENTICATED_TITLE } from '../common/Constants';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private titleSubject = new BehaviorSubject<string>(DEFAULT_TITLE);

  constructor(private title: Title) {
    // Subscribe to title changes
    this.titleSubject.subscribe(newTitle => {
      this.title.setTitle(newTitle);
    });
  }

  setTitle(isAuthenticated: boolean) {
    if (isAuthenticated) {
      this.titleSubject.next(AUTHENTICATED_TITLE);
    } else {
      this.titleSubject.next(DEFAULT_TITLE);
    }
  }
} 